import React from 'react';
import { Box, Typography, Button, Container, Card, CardContent } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { convertToAmPm } from '../controller.tsx';

const SkeletonEvent = () => {
  const { id, name, description, location, address, logo, date, time_string, duration, link } = useParams();
  const navigate = useNavigate(); // Hook for programmatically navigating
//  const formattedTime = new Date(date).toLocaleString('en-US', {
//    weekday: 'short',
//    year: 'numeric',
//    month: 'short',
//    day: 'numeric',
//  });
  console.log(date);
  // Navigate back to home page
  const handleBackToHome = () => {
    navigate('/'); // This will navigate to the home page ("/")
  };

  console.log(id, duration) //todo: delete
  return (
    <Container
      sx={{
        paddingTop: 2,
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: 2 }}>
          <img
            src={logo}
            alt="Event Logo"
            style={{
              width: '100%',
              maxWidth: 400,
              height: 200,
              objectFit: 'cover',
              borderRadius: '8px', // Adding border radius for a nicer effect
            }}
          />
        </Box>
        {/* Box sx={{
            padding: 3,
            borderRadius: 2,
            boxShadow: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            '@media (max-width: 600px)': {
              padding: 2,
            },
          }}*/}
        <Card>
          <CardContent>
            <Typography variant="h6" sx={{
              textAlign: 'center', fontWeight: 'bold', paddingY: 1, fontSize: '1.2rem',
              '@media (max-width: 600px)': {
                fontSize: '1rem', // Adjust font size for smaller screens
              },
            }}>
              {name}
            </Typography>
            {description !== " " ? (
              <Typography sx={{ paddingBottom: 2 }}>
                {description}
              </Typography>
            ) : (
              <Typography sx={{ paddingBottom: 2, fontStyle: 'italic' }}>
                No description available
              </Typography>
            )}
            <Box sx={{ paddingY: 2 }}
              onClick={() => {
                window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location)}`, '_blank');
              }}
            >
              <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                {location}
              </Typography>
              <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                {address}
              </Typography>
            </Box>
            { /*
            <Typography sx={{ paddingBottom: 1 }}>
              {formattedTime}
            </Typography>
            */ }
            <Typography sx={{ paddingBottom: 1 }}>
              {convertToAmPm(time_string)}
            </Typography>
            <a href={link} target="_blank" rel="noopener noreferrer" style={{ color: '#37474F', textDecoration: 'none' }}>
              <Button variant="text" sx={{ color: '#37474F' }}>
                {link}
              </Button>
            </a>

            <Button
              variant="contained"
              color="primary"
              onClick={handleBackToHome}
              sx={{
                backgroundColor: '#263238',
                marginTop: 3,
                width: '100%',
                padding: '10px 0',
                fontSize: '1.1rem',
                '@media (max-width: 600px)': {
                  fontSize: '1rem',
                  padding: '12px 0',
                },
              }}
            >
              Back to Home
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default SkeletonEvent;
